import {Component, OnDestroy, OnInit} from '@angular/core';
import {BaseService} from "../../services/base.service";
import {takeUntil} from "rxjs/operators";
import {Polls, PollsData} from "../../interfaces/polls";
import {HttpClient} from "@angular/common/http";
import {Subject} from "rxjs";
import {RequestData} from "../../interfaces/request-data";
import {Router} from "@angular/router";
import {Meta, Title} from "@angular/platform-browser";

@Component({
  selector: 'app-polls',
  templateUrl: './polls.component.html',
  styleUrls: ['./polls.component.scss']
})
export class PollsComponent extends BaseService implements OnDestroy, OnInit {
  public isDestroyed: Subject<boolean> = new Subject();
  public pollsData: PollsData;
  // Кожен клік по варіанту одразу пише відповідь (бек дубль не перевіряє), а на account
  // переходимо лише після відповіді - другий швидкий клік давав другий запис в опитуванні.
  public isAnswering: boolean = false;
  // Сторінку вже закрито: complete на takeUntil(isDestroyed) спрацьовує і при виході зі сторінки
  private isLeft: boolean = false;
  constructor(
    private http: HttpClient,
    private router: Router,
    private titleService: Title,
    private meta: Meta,
  ) {
    super();

    const title = 'Маслоточка | Опитування';
    this.titleService.setTitle(title);
    this.meta.addTag({ name: 'title', content: title });
    this.meta.addTag({ name: 'og:title', content: title });
    this.meta.addTag({ name: 'twitter:title', content: title });
    this.meta.addTag({ name: 'DC.title', content: title });
  }

  ngOnInit() {
    this.http.get(this.apiRoot + 'polls/data')
      .pipe(takeUntil(this.isDestroyed))
      .subscribe((data: Polls) => {
        if (data.data && data.data.id) {
          this.pollsData = data.data;
        } else {
          setTimeout(() => {
            this.router.navigate(['account']);
          }, 500);
        }
      });
  }

  pollChecked(index: number, id: number) {
    if (this.isAnswering) {
      return;
    }

    this.isAnswering = true;
    let isAnswered = false;

    this.http.post(this.apiRoot + 'polls/answer', {
      answer: index,
      poll_id: id
    })
      .pipe(takeUntil(this.isDestroyed))
      .subscribe({
        next: (data: RequestData) => {
          isAnswered = true;

          if (data && data.data === 'success') {
            this.router.navigate(['account']);
          } else {
            this.isAnswering = false;
          }
        },
        // Відповідь могла записатись до обриву - повтор дав би дубль. Незаписане опитування
        // polls/data покаже знову, тож просто повертаємо в кабінет.
        error: () => this.router.navigate(['account']),
        // «Скасувати» в лоадері завершує запит без відповіді: варіанти лишались вимкненими
        // (isAnswering), і клієнт застрягав на сторінці - так само, як при помилці, йдемо в кабінет
        // Вихід зі сторінки під час запиту теж завершує його без відповіді - тоді клієнта не чіпаємо,
        // інакше його з обраної сторінки (кошик, меню) перекидало в кабінет
        complete: () => {
          if (!isAnswered && !this.isLeft) {
            this.router.navigate(['account']);
          }
        }
      });
  }

  ngOnDestroy() {
    this.isLeft = true;
    this.isDestroyed.next(true);
    this.isDestroyed.complete();
  }
}
